/**
 * Returns a promise that resolves after {@link duration} milliseconds.
 */
export const sleep = (duration: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, duration);
  });
